import * as React from "react";
export const FilterSvg = ({ size = 32 }: { size?: number }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.8607 6.95857C11.5181 6.95857 11.1896 7.09466 10.9473 7.33689C10.7051 7.57912 10.569 7.90766 10.569 8.25024C10.569 8.59281 10.7051 8.92135 10.9473 9.16358C11.1896 9.40582 11.5181 9.5419 11.8607 9.5419C12.2032 9.5419 12.5318 9.40582 12.774 9.16358C13.0163 8.92135 13.1523 8.59281 13.1523 8.25024C13.1523 7.90766 13.0163 7.57912 12.774 7.33689C12.5318 7.09466 12.2032 6.95857 11.8607 6.95857ZM8.20526 6.95857C8.47212 6.20226 8.96701 5.54734 9.6217 5.08409C10.2764 4.62084 11.0587 4.37207 11.8607 4.37207C12.6627 4.37207 13.445 4.62084 14.0997 5.08409C14.7543 5.54734 15.2492 6.20226 15.5161 6.95857H24.7773C25.1199 6.95857 25.4485 7.09466 25.6907 7.33689C25.9329 7.57912 26.069 7.90766 26.069 8.25024C26.069 8.59281 25.9329 8.92135 25.6907 9.16358C25.4485 9.40582 25.1199 9.5419 24.7773 9.5419H15.5161C15.2492 10.2982 14.7543 10.9531 14.0997 11.4164C13.445 11.8796 12.6627 12.1284 11.8607 12.1284C11.0587 12.1284 10.2764 11.8796 9.6217 11.4164C8.96701 10.9531 8.47212 10.2982 8.20526 9.5419H6.69401C6.35144 9.5419 6.0229 9.40582 5.78066 9.16358C5.53843 8.92135 5.40234 8.59281 5.40234 8.25024C5.40234 7.90766 5.53843 7.57912 5.78066 7.33689C6.0229 7.09466 6.35144 6.95857 6.69401 6.95857H8.20526ZM19.6107 14.7086C19.2681 14.7086 18.9396 14.8447 18.6973 15.0869C18.4551 15.3291 18.319 15.6577 18.319 16.0002C18.319 16.3428 18.4551 16.6713 18.6973 16.9136C18.9396 17.1558 19.2681 17.2919 19.6107 17.2919C19.9532 17.2919 20.2818 17.1558 20.524 16.9136C20.7663 16.6713 20.9023 16.3428 20.9023 16.0002C20.9023 15.6577 20.7663 15.3291 20.524 15.0869C20.2818 14.8447 19.9532 14.7086 19.6107 14.7086ZM15.9553 14.7086C16.2221 13.9523 16.717 13.2973 17.3717 12.8341C18.0264 12.3708 18.8087 12.1221 19.6107 12.1221C20.4127 12.1221 21.195 12.3708 21.8497 12.8341C22.5043 13.2973 22.9992 13.9523 23.2661 14.7086H24.7773C25.1199 14.7086 25.4485 14.8447 25.6907 15.0869C25.9329 15.3291 26.069 15.6577 26.069 16.0002C26.069 16.3428 25.9329 16.6713 25.6907 16.9136C25.4485 17.1558 25.1199 17.2919 24.7773 17.2919H23.2661C22.9992 18.0482 22.5043 18.7031 21.8497 19.1664C21.195 19.6296 20.4127 19.8784 19.6107 19.8784C18.8087 19.8784 18.0264 19.6296 17.3717 19.1664C16.717 18.7031 16.2221 18.0482 15.9553 17.2919H6.69401C6.35144 17.2919 6.0229 17.1558 5.78066 16.9136C5.53843 16.6713 5.40234 16.3428 5.40234 16.0002C5.40234 15.6577 5.53843 15.3291 5.78066 15.0869C6.0229 14.8447 6.35144 14.7086 6.69401 14.7086H15.9553ZM11.8607 22.4586C11.5181 22.4586 11.1896 22.5947 10.9473 22.8369C10.7051 23.0791 10.569 23.4077 10.569 23.7502C10.569 24.0928 10.7051 24.4214 10.9473 24.6636C11.1896 24.9058 11.5181 25.0419 11.8607 25.0419C12.2032 25.0419 12.5318 24.9058 12.774 24.6636C13.0163 24.4214 13.1523 24.0928 13.1523 23.7502C13.1523 23.4077 13.0163 23.0791 12.774 22.8369C12.5318 22.5947 12.2032 22.4586 11.8607 22.4586ZM8.20526 22.4586C8.47212 21.7023 8.96701 21.0473 9.6217 20.5841C10.2764 20.1208 11.0587 19.8721 11.8607 19.8721C12.6627 19.8721 13.445 20.1208 14.0997 20.5841C14.7543 21.0473 15.2492 21.7023 15.5161 22.4586H24.7773C25.1199 22.4586 25.4485 22.5947 25.6907 22.8369C25.9329 23.0791 26.069 23.4077 26.069 23.7502C26.069 24.0928 25.9329 24.4214 25.6907 24.6636C25.4485 24.9058 25.1199 25.0419 24.7773 25.0419H15.5161C15.2492 25.7982 14.7543 26.4531 14.0997 26.9164C13.445 27.3796 12.6627 27.6284 11.8607 27.6284C11.0587 27.6284 10.2764 27.3796 9.6217 26.9164C8.96701 26.4531 8.47212 25.7982 8.20526 25.0419H6.69401C6.35144 25.0419 6.0229 24.9058 5.78066 24.6636C5.53843 24.4214 5.40234 24.0928 5.40234 23.7502C5.40234 23.4077 5.53843 23.0791 5.78066 22.8369C6.0229 22.5947 6.35144 22.4586 6.69401 22.4586H8.20526Z"
            fill="black"
            fill-opacity="0.5"
        />
    </svg>
);

export const DownloadSvg = () => (
    <svg
        width="17px"
        height="17px"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z"
            fill="white"
        />
    </svg>
);

export const SearchSvg = ({ size = 18 }: { size?: number }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15.677 16.385L9.415 10.123C8.915 10.549 8.34 10.8787 7.69 11.112C7.04 11.3453 6.38667 11.462 5.73 11.462C4.12867 11.462 2.77333 10.9077 1.664 9.799C0.554667 8.69034 0 7.33534 0 5.734C0 4.13267 0.554 2.777 1.662 1.667C2.77 0.557002 4.12467 0.00133573 5.726 2.39808e-06C7.32733 -0.00133094 8.68333 0.553336 9.794 1.664C10.9047 2.77467 11.46 4.13034 11.46 5.731C11.46 6.42567 11.337 7.098 11.091 7.748C10.845 8.398 10.5217 8.954 10.121 9.416L16.383 15.677L15.677 16.385ZM5.731 10.461C7.05767 10.461 8.17767 10.0043 9.091 9.091C10.0043 8.17767 10.461 7.05734 10.461 5.73C10.461 4.40267 10.0043 3.28267 9.091 2.37C8.17767 1.45734 7.05767 1.00067 5.731 1C4.40433 0.999336 3.284 1.456 2.37 2.37C1.456 3.284 0.999333 4.404 1 5.73C1.00067 7.056 1.45733 8.176 2.37 9.09C3.28267 10.004 4.40267 10.4607 5.73 10.46"
            fill="#7C7C7C"
        />
    </svg>
);
export const ArrowRightSvg = ({ color = "black" }: { color?: string }) => (
    <svg
        width="40"
        height="37"
        viewBox="0 0 40 37"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M21.3276 2.85551L37.2578 18.4102L21.3276 33.9648M35.0453 18.4102H2.74235"
            stroke={color}
            stroke-width="5.12791"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
export const ArrowLeftSvg = ({ color = "black" }: { color?: string }) => (
    <svg
        width="40"
        height="37"
        viewBox="0 0 40 37"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18.6724 2.85551L2.74219 18.4102L18.6724 33.9648M4.95472 18.4102H37.2577"
            stroke={color}
            stroke-width="5.12791"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
export const TimerSvg = () => (
    <svg
        width="45"
        height="40"
        viewBox="0 0 45 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.43145 2C6.88919 2.40938 5.48286 3.214 4.35387 4.33295C3.22489 5.4519 2.41306 6.84573 2 8.37428M35.8714 2C37.4137 2.40938 38.82 3.214 39.949 4.33295C41.078 5.4519 41.8898 6.84573 42.3029 8.37428"
            fill="#EF9A44"
        />
        <path
            d="M8.43145 2C6.88919 2.40938 5.48286 3.214 4.35387 4.33295C3.22489 5.4519 2.41306 6.84573 2 8.37428M35.8714 2C37.4137 2.40938 38.82 3.214 39.949 4.33295C41.078 5.4519 41.8898 6.84573 42.3029 8.37428"
            stroke="#EF9A44"
            stroke-width="3.44388"
            stroke-linecap="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.1481 39.9993C26.9717 39.9993 31.5977 38.1002 35.0084 34.7198C38.4192 31.3393 40.3354 26.7545 40.3354 21.9738C40.3354 17.1931 38.4192 12.6082 35.0084 9.2278C31.5977 5.84736 26.9717 3.94824 22.1481 3.94824C17.3246 3.94824 12.6986 5.84736 9.28785 9.2278C5.87708 12.6082 3.96094 17.1931 3.96094 21.9738C3.96094 26.7545 5.87708 31.3393 9.28785 34.7198C12.6986 38.1002 17.3246 39.9993 22.1481 39.9993ZM24.4215 12.961C24.4215 12.3634 24.182 11.7903 23.7557 11.3678C23.3293 10.9452 22.7511 10.7078 22.1481 10.7078C21.5452 10.7078 20.967 10.9452 20.5406 11.3678C20.1143 11.7903 19.8747 12.3634 19.8747 12.961V21.4105C19.8747 22.9652 21.1479 24.227 22.7165 24.227H28.9684C29.5713 24.227 30.1495 23.9896 30.5759 23.567C31.0022 23.1445 31.2418 22.5714 31.2418 21.9738C31.2418 21.3762 31.0022 20.8031 30.5759 20.3805C30.1495 19.958 29.5713 19.7206 28.9684 19.7206H24.4215V12.961Z"
            fill="#EF9A44"
        />
    </svg>
);

export const RoundSvg = ({ color, size = 13 }: { color: string; size?: number }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="6.46789" cy="6.50012" r="6.46789" fill={color} />
    </svg>
);
export const QuizInCorrectSvg = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_3263_4116)">
            <path
                d="M13.119 12L17.769 7.35C17.8425 7.27653 17.9008 7.1893 17.9405 7.0933C17.9803 6.9973 18.0008 6.89441 18.0008 6.7905C18.0008 6.68659 17.9803 6.5837 17.9405 6.4877C17.9008 6.3917 17.8425 6.30447 17.769 6.231C17.6955 6.15753 17.6083 6.09924 17.5123 6.05948C17.4163 6.01971 17.3134 5.99925 17.2095 5.99925C17.1056 5.99925 17.0027 6.01971 16.9067 6.05948C16.8107 6.09924 16.7235 6.15753 16.65 6.231L12 10.881L7.35 6.231C7.27653 6.15753 7.1893 6.09924 7.0933 6.05948C6.9973 6.01971 6.89441 5.99925 6.7905 5.99925C6.68659 5.99925 6.5837 6.01971 6.4877 6.05948C6.3917 6.09924 6.30447 6.15753 6.231 6.231C6.15753 6.30447 6.09924 6.3917 6.05948 6.4877C6.01971 6.5837 5.99925 6.68659 5.99925 6.7905C5.99925 6.89441 6.01971 6.9973 6.05948 7.0933C6.09924 7.1893 6.15753 7.27653 6.231 7.35L10.881 12L6.231 16.65C6.15753 16.7235 6.09924 16.8107 6.05948 16.9067C6.01971 17.0027 5.99925 17.1056 5.99925 17.2095C5.99925 17.3134 6.01971 17.4163 6.05948 17.5123C6.09924 17.6083 6.15753 17.6955 6.231 17.769C6.30447 17.8425 6.3917 17.9008 6.4877 17.9405C6.5837 17.9803 6.68659 18.0008 6.7905 18.0008C6.89441 18.0008 6.9973 17.9803 7.0933 17.9405C7.1893 17.9008 7.27653 17.8425 7.35 17.769L12 13.119L16.65 17.769C16.7235 17.8425 16.8107 17.9008 16.9067 17.9405C17.0027 17.9803 17.1056 18.0008 17.2095 18.0008C17.3134 18.0008 17.4163 17.9803 17.5123 17.9405C17.6083 17.9008 17.6955 17.8425 17.769 17.769C17.8425 17.6955 17.9008 17.6083 17.9405 17.5123C17.9803 17.4163 18.0008 17.3134 18.0008 17.2095C18.0008 17.1056 17.9803 17.0027 17.9405 16.9067C17.9008 16.8107 17.8425 16.7235 17.769 16.65L13.119 12ZM12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24Z"
                fill="#EA4335"
            />
        </g>
        <defs>
            <clipPath id="clip0_3263_4116">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const QuizCorrectSvg = () => (
    <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_3263_4173)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 11.5C0 8.45001 1.2116 5.52494 3.36827 3.36827C5.52494 1.2116 8.45001 0 11.5 0C14.55 0 17.4751 1.2116 19.6317 3.36827C21.7884 5.52494 23 8.45001 23 11.5C23 14.55 21.7884 17.4751 19.6317 19.6317C17.4751 21.7884 14.55 23 11.5 23C8.45001 23 5.52494 21.7884 3.36827 19.6317C1.2116 17.4751 0 14.55 0 11.5ZM10.8437 16.422L17.4647 8.14507L16.2687 7.18827L10.6229 14.2431L6.624 10.9112L5.64267 12.0888L10.8437 16.422Z"
                fill="#3EAF3F"
            />
        </g>
        <defs>
            <clipPath id="clip0_3263_4173">
                <rect width="23" height="23" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

// Quiz List
export const QuizQuestionSvg = () => (
    <svg
        width="18"
        height="22"
        viewBox="0 0 18 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17 6V20C17 20.2652 16.8946 20.5196 16.7071 20.7071C16.5196 20.8946 16.2652 21 16 21H2C1.73478 21 1.48043 20.8946 1.29289 20.7071C1.10536 20.5196 1 20.2652 1 20V2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1H12M17 6H12V1M17 6L12 1"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9 14.5V13C10.105 13 11 11.9925 11 10.75C11 9.5075 10.105 8.5 9 8.5C7.895 8.5 7 9.5075 7 10.75"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9 18.5C9.33152 18.5 9.64946 18.3683 9.88388 18.1339C10.1183 17.8995 10.25 17.5815 10.25 17.25C10.25 16.9185 10.1183 16.6005 9.88388 16.3661C9.64946 16.1317 9.33152 16 9 16C8.66848 16 8.35054 16.1317 8.11612 16.3661C7.8817 16.6005 7.75 16.9185 7.75 17.25C7.75 17.5815 7.8817 17.8995 8.11612 18.1339C8.35054 18.3683 8.66848 18.5 9 18.5Z"
            fill="white"
        />
    </svg>
);
export const QuizTimeLimitSvg = () => (
    <svg
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2ZM10 4C10.2449 4.00003 10.4813 4.08996 10.6644 4.25272C10.8474 4.41547 10.9643 4.63975 10.993 4.883L11 5V9.586L13.707 12.293C13.8863 12.473 13.9905 12.7144 13.9982 12.9684C14.006 13.2223 13.9168 13.4697 13.7488 13.6603C13.5807 13.8508 13.3464 13.9703 13.0935 13.9944C12.8406 14.0185 12.588 13.9454 12.387 13.79L12.293 13.707L9.293 10.707C9.13758 10.5514 9.03776 10.349 9.009 10.131L9 10V5C9 4.73478 9.10536 4.48043 9.29289 4.29289C9.48043 4.10536 9.73478 4 10 4Z"
            fill="white"
        />
    </svg>
);
export const QuizLevelSvg = () => (
    <svg
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M14 8.78L18.24 1.45L19.97 2.45L14.74 11.5L8.23 7.75L3.46 16H20V18H0V0H2V14.54L7.5 5L14 8.78Z"
            fill="white"
        />
    </svg>
);

export const TimeLeftSVG = ({ size = 22 }: { size?: number }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2ZM10 4C10.2449 4.00003 10.4813 4.08996 10.6644 4.25272C10.8474 4.41547 10.9643 4.63975 10.993 4.883L11 5V9.586L13.707 12.293C13.8863 12.473 13.9905 12.7144 13.9982 12.9684C14.006 13.2223 13.9168 13.4697 13.7488 13.6603C13.5807 13.8508 13.3464 13.9703 13.0935 13.9944C12.8406 14.0185 12.588 13.9454 12.387 13.79L12.293 13.707L9.293 10.707C9.13758 10.5514 9.03776 10.349 9.009 10.131L9 10V5C9 4.73478 9.10536 4.48043 9.29289 4.29289C9.48043 4.10536 9.73478 4 10 4Z"
            fill="black"
        />
    </svg>
);

export const QuestionSVG = ({ size = 22 }: { size?: number }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 18 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17 6V20C17 20.2652 16.8946 20.5196 16.7071 20.7071C16.5196 20.8946 16.2652 21 16 21H2C1.73478 21 1.48043 20.8946 1.29289 20.7071C1.10536 20.5196 1 20.2652 1 20V2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1H12M17 6H12V1M17 6L12 1"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9 14.5V13C10.105 13 11 11.9925 11 10.75C11 9.5075 10.105 8.5 9 8.5C7.895 8.5 7 9.5075 7 10.75"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9 18.5C9.33152 18.5 9.64946 18.3683 9.88388 18.1339C10.1183 17.8995 10.25 17.5815 10.25 17.25C10.25 16.9185 10.1183 16.6005 9.88388 16.3661C9.64946 16.1317 9.33152 16 9 16C8.66848 16 8.35054 16.1317 8.11612 16.3661C7.8817 16.6005 7.75 16.9185 7.75 17.25C7.75 17.5815 7.8817 17.8995 8.11612 18.1339C8.35054 18.3683 8.66848 18.5 9 18.5Z"
            fill="black"
        />
    </svg>
);

export const TestApperedSvg = ({ size = 44 }: { size?: number }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17.168 11.1248C17.168 10.8044 17.2953 10.497 17.5219 10.2704C17.7485 10.0438 18.0558 9.9165 18.3763 9.9165H28.043C28.3634 9.9165 28.6708 10.0438 28.8974 10.2704C29.124 10.497 29.2513 10.8044 29.2513 11.1248C29.2513 11.4453 29.124 11.7527 28.8974 11.9793C28.6708 12.2059 28.3634 12.3332 28.043 12.3332H18.3763C18.0558 12.3332 17.7485 12.2059 17.5219 11.9793C17.2953 11.7527 17.168 11.4453 17.168 11.1248ZM18.3763 14.7498C18.0558 14.7498 17.7485 14.8771 17.5219 15.1037C17.2953 15.3304 17.168 15.6377 17.168 15.9582C17.168 16.2786 17.2953 16.586 17.5219 16.8126C17.7485 17.0392 18.0558 17.1665 18.3763 17.1665H28.043C28.3634 17.1665 28.6708 17.0392 28.8974 16.8126C29.124 16.586 29.2513 16.2786 29.2513 15.9582C29.2513 15.6377 29.124 15.3304 28.8974 15.1037C28.6708 14.8771 28.3634 14.7498 28.043 14.7498H18.3763ZM17.168 26.8332C17.168 26.5127 17.2953 26.2054 17.5219 25.9788C17.7485 25.7521 18.0558 25.6248 18.3763 25.6248H28.043C28.3634 25.6248 28.6708 25.7521 28.8974 25.9788C29.124 26.2054 29.2513 26.5127 29.2513 26.8332C29.2513 27.1536 29.124 27.461 28.8974 27.6876C28.6708 27.9142 28.3634 28.0415 28.043 28.0415H18.3763C18.0558 28.0415 17.7485 27.9142 17.5219 27.6876C17.2953 27.461 17.168 27.1536 17.168 26.8332ZM18.3763 30.4582C18.0558 30.4582 17.7485 30.5855 17.5219 30.8121C17.2953 31.0387 17.168 31.346 17.168 31.6665C17.168 31.987 17.2953 32.2943 17.5219 32.5209C17.7485 32.7475 18.0558 32.8748 18.3763 32.8748H28.043C28.3634 32.8748 28.6708 32.7475 28.8974 32.5209C29.124 32.2943 29.2513 31.987 29.2513 31.6665C29.2513 31.346 29.124 31.0387 28.8974 30.8121C28.6708 30.5855 28.3634 30.4582 28.043 30.4582H18.3763Z"
            fill="#C36200"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.08203 25.6248C5.08203 25.3044 5.20934 24.997 5.43594 24.7704C5.66255 24.5438 5.96989 24.4165 6.29036 24.4165H12.332C12.6525 24.4165 12.9598 24.5438 13.1865 24.7704C13.4131 24.997 13.5404 25.3044 13.5404 25.6248V31.6665C13.5404 31.987 13.4131 32.2943 13.1865 32.5209C12.9598 32.7475 12.6525 32.8748 12.332 32.8748H6.29036C5.96989 32.8748 5.66255 32.7475 5.43594 32.5209C5.20934 32.2943 5.08203 31.987 5.08203 31.6665V25.6248ZM7.4987 26.8332V30.4582H11.1237V26.8332H7.4987Z"
            fill="#C36200"
        />
        <path
            d="M14.3954 11.9794C14.6155 11.7515 14.7373 11.4463 14.7346 11.1295C14.7318 10.8127 14.6047 10.5096 14.3807 10.2856C14.1567 10.0615 13.8536 9.93444 13.5368 9.93169C13.22 9.92893 12.9147 10.0507 12.6868 10.2708L8.70781 14.2499L7.14543 12.6875C6.91754 12.4674 6.61231 12.3456 6.29549 12.3484C5.97867 12.3511 5.6756 12.4782 5.45157 12.7022C5.22753 12.9263 5.10046 13.2293 5.0977 13.5461C5.09495 13.863 5.21674 14.1682 5.43685 14.3961L8.70781 17.667L14.3954 11.9794Z"
            fill="#C36200"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.08333 0.25C3.80145 0.25 2.57208 0.759225 1.66565 1.66565C0.759225 2.57208 0.25 3.80145 0.25 5.08333V38.9167C0.25 40.1985 0.759225 41.4279 1.66565 42.3344C2.57208 43.2408 3.80145 43.75 5.08333 43.75H29.25C30.5319 43.75 31.7613 43.2408 32.6677 42.3344C33.5741 41.4279 34.0833 40.1985 34.0833 38.9167V5.08333C34.0833 3.80145 33.5741 2.57208 32.6677 1.66565C31.7613 0.759225 30.5319 0.25 29.25 0.25H5.08333ZM2.66667 5.08333C2.66667 4.44239 2.92128 3.82771 3.37449 3.37449C3.82771 2.92128 4.44239 2.66667 5.08333 2.66667H29.25C29.8909 2.66667 30.5056 2.92128 30.9588 3.37449C31.4121 3.82771 31.6667 4.44239 31.6667 5.08333V38.9167C31.6667 39.5576 31.4121 40.1723 30.9588 40.6255C30.5056 41.0787 29.8909 41.3333 29.25 41.3333H5.08333C4.44239 41.3333 3.82771 41.0787 3.37449 40.6255C2.92128 40.1723 2.66667 39.5576 2.66667 38.9167V5.08333ZM36.5 12.3333C36.5 11.3719 36.8819 10.4499 37.5617 9.77007C38.2416 9.09025 39.1636 8.70833 40.125 8.70833C41.0864 8.70833 42.0084 9.09025 42.6883 9.77007C43.3681 10.4499 43.75 11.3719 43.75 12.3333V36.8661L40.125 42.3036L36.5 36.8661V12.3333ZM40.125 11.125C39.8045 11.125 39.4972 11.2523 39.2706 11.4789C39.044 11.7055 38.9167 12.0129 38.9167 12.3333V14.75H41.3333V12.3333C41.3333 12.0129 41.206 11.7055 40.9794 11.4789C40.7528 11.2523 40.4455 11.125 40.125 11.125ZM40.125 37.9464L38.9167 36.1339V17.1667H41.3333V36.1339L40.125 37.9464Z"
            fill="#C36200"
        />
    </svg>
);
export const AverageMarkSvg = ({ size = 58 }: { size?: number }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 58 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M41.6867 43.5C35.1617 43.5 32.5698 35.931 30.0632 28.6121C27.6888 21.6739 25.2292 14.5 19.9367 14.5C18.7007 14.5728 17.5144 15.012 16.5289 15.7615C15.5434 16.511 14.8034 17.537 14.4032 18.7086L10.9648 17.5522C11.0573 17.2804 13.2685 10.875 19.9367 10.875C27.8211 10.875 30.8335 19.6747 33.4942 27.4376C35.6855 33.8339 37.7536 39.875 41.6867 39.875C42.9225 39.8023 44.1087 39.3634 45.0941 38.6143C46.0796 37.8651 46.8197 36.8395 47.2203 35.6682L50.6568 36.8228C50.5662 37.0946 48.3549 43.5 41.6867 43.5Z"
            fill="#1A6847"
        />
        <path
            d="M7.25 50.75V30.8125H10.875V27.1875H7.25V3.625H3.625V50.75C3.625 51.7114 4.00692 52.6334 4.68674 53.3133C5.36656 53.9931 6.28859 54.375 7.25 54.375H54.375V50.75H7.25Z"
            fill="#1A6847"
        />
        <path
            d="M14.5 27.1875H18.125V30.8125H14.5V27.1875ZM21.75 27.1875H25.375V30.8125H21.75V27.1875ZM36.25 27.1875H39.875V30.8125H36.25V27.1875ZM43.5 27.1875H47.125V30.8125H43.5V27.1875ZM50.75 27.1875H54.375V30.8125H50.75V27.1875Z"
            fill="#1A6847"
        />
    </svg>
);
export const HighestMarkSvg = ({ size = 58 }: { size?: number }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 58 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M21.0177 7.854H36.9823C37.4173 7.854 37.7918 7.854 38.1302 7.89509C39.3426 8.0461 40.4689 8.60106 41.3273 9.47047C42.1858 10.3399 42.7264 11.4731 42.862 12.6873H44.8098C45.3222 12.6825 46.4459 12.6728 47.3739 13.2939C48.575 14.0938 48.9375 15.4689 48.9375 16.9165C48.9375 23.5043 45.4261 27.9027 40.9432 30.3459C38.4419 34.8989 33.8213 38.0623 29 38.0623C25.3291 38.0623 21.8467 36.0758 19.3406 33.3281C18.5079 32.4196 17.7769 31.4229 17.1607 30.3556C12.6802 27.9244 9.0625 23.5309 9.0625 16.9165C9.0625 15.4665 9.425 14.0938 10.6237 13.2939C11.5541 12.6728 12.6778 12.6825 13.1902 12.6873H15.138L15.1453 12.6197C15.2947 11.4187 15.8405 10.3019 16.6963 9.44609C17.552 8.59032 18.6688 8.0445 19.8698 7.89509C20.2082 7.854 20.5827 7.854 21.0177 7.854ZM18.7292 14.4998V14.5071L18.705 22.9582V22.9606C18.705 24.703 19.2028 26.4841 20.0656 28.1153L20.0994 28.1758C20.619 29.1473 21.2691 30.0608 22.0207 30.8824C24.0555 33.1154 26.6317 34.4373 29.0024 34.4373C32.4389 34.4373 36.0615 31.953 37.9441 28.2893C38.7993 26.6423 39.2468 24.814 39.2491 22.9582L39.2443 22.9533L39.2733 13.8643C39.2733 13.2794 39.2684 13.1513 39.2588 13.0668C39.2087 12.667 39.0268 12.2952 38.7419 12.0103C38.457 11.7254 38.0853 11.5436 37.6855 11.4935C37.42 11.4777 37.1539 11.4729 36.888 11.479H21.1144C20.5272 11.479 20.4015 11.4814 20.3169 11.4935C19.9171 11.5436 19.5454 11.7254 19.2605 12.0103C18.9756 12.2952 18.7937 12.667 18.7437 13.0668C18.7279 13.3323 18.723 13.5983 18.7292 13.8643V14.4998ZM42.891 16.3123L42.8693 22.9582V22.9606M42.8137 24.2632C44.3555 22.4072 45.3149 19.9857 45.3149 16.9165C45.3149 16.6313 45.2908 16.4428 45.269 16.3244C45.0831 16.3132 44.8969 16.3092 44.7108 16.3123H42.891M15.1283 24.123C15.0919 23.7358 15.0741 23.3471 15.0752 22.9582V22.9533L15.0969 16.3123H13.2917C13.0283 16.3123 12.8615 16.3123 12.7334 16.3244C12.6995 16.5199 12.6841 16.7181 12.6875 16.9165C12.6875 19.9059 13.6252 22.2815 15.1283 24.123ZM29 39.2707C29.4807 39.2707 29.9417 39.4616 30.2816 39.8015C30.6215 40.1414 30.8125 40.6025 30.8125 41.0832V46.5207H38.6667C39.1474 46.5207 39.6084 46.7116 39.9483 47.0515C40.2882 47.3914 40.4792 47.8525 40.4792 48.3332C40.4792 48.8139 40.2882 49.2749 39.9483 49.6148C39.6084 49.9547 39.1474 50.1457 38.6667 50.1457H19.3333C18.8526 50.1457 18.3916 49.9547 18.0517 49.6148C17.7118 49.2749 17.5208 48.8139 17.5208 48.3332C17.5208 47.8525 17.7118 47.3914 18.0517 47.0515C18.3916 46.7116 18.8526 46.5207 19.3333 46.5207H27.1875V41.0832C27.1875 40.6025 27.3785 40.1414 27.7184 39.8015C28.0583 39.4616 28.5193 39.2707 29 39.2707Z"
            fill="#5F4C78"
        />
        <path
            d="M28.4426 15.841C28.489 15.732 28.5665 15.6391 28.6653 15.5738C28.7641 15.5085 28.88 15.4736 28.9984 15.4736C29.1169 15.4736 29.2327 15.5085 29.3316 15.5738C29.4304 15.6391 29.5078 15.732 29.5543 15.841L30.7747 18.77C30.8173 18.8722 30.8871 18.9608 30.9766 19.026C31.0661 19.0912 31.1718 19.1306 31.2822 19.1398L34.4456 19.3935C34.5646 19.4029 34.6781 19.4474 34.7719 19.5213C34.8656 19.5952 34.9354 19.6952 34.9723 19.8087C35.0093 19.9222 35.0118 20.0441 34.9796 20.159C34.9474 20.2739 34.8818 20.3767 34.7912 20.4544L32.3818 22.5183C32.2975 22.5907 32.2349 22.685 32.2008 22.7908C32.1667 22.8965 32.1624 23.0096 32.1884 23.1176L32.9231 26.2013C32.9514 26.3176 32.9445 26.4398 32.9033 26.5522C32.862 26.6647 32.7883 26.7623 32.6914 26.8328C32.5946 26.9032 32.4789 26.9433 32.3593 26.9479C32.2396 26.9525 32.1212 26.9214 32.0193 26.8586L29.3126 25.2056C29.2179 25.148 29.1092 25.1175 28.9984 25.1175C28.8876 25.1175 28.7789 25.148 28.6843 25.2056L25.9776 26.8586C25.8756 26.9214 25.7573 26.9525 25.6376 26.9479C25.5179 26.9433 25.4023 26.9032 25.3054 26.8328C25.2086 26.7623 25.1348 26.6647 25.0936 26.5522C25.0523 26.4398 25.0454 26.3176 25.0738 26.2013L25.8108 23.1176C25.8368 23.0096 25.8325 22.8965 25.7984 22.7908C25.7643 22.685 25.7017 22.5907 25.6175 22.5183L23.2057 20.4544C23.1142 20.3769 23.0479 20.2739 23.0152 20.1586C22.9824 20.0433 22.9847 19.9208 23.0218 19.8068C23.0588 19.6928 23.129 19.5924 23.2232 19.5184C23.3175 19.4444 23.4317 19.4 23.5513 19.3911L26.7123 19.1398C26.823 19.131 26.9292 19.0918 27.0192 19.0266C27.1092 18.9614 27.1794 18.8726 27.2222 18.77L28.4426 15.841Z"
            fill="#5F4C78"
        />
    </svg>
);
export const LeftQuestionArrowSvg = ({ size = 28, color = "#897bdb" }: { size?: number; color?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
    >
        <path
            fill={color}
            fill-rule="evenodd"
            d="m16.75 17l-7.5-5l7.5-5a.901.901 0 1 0-1-1.5l-8.502 5.668a1 1 0 0 0 0 1.664L15.75 18.5a.901.901 0 1 0 1-1.5"
        />
    </svg>
);
export const RightQuestionArrowSvg = ({ size = 28, color = "#897bdb" }: { size?: number; color?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
    >
        <path
            fill={color}
            fill-rule="evenodd"
            d="m7.25 17l7.5-5l-7.5-5a.901.901 0 1 1 1-1.5l8.502 5.668a1 1 0 0 1 0 1.664L8.25 18.5a.901.901 0 1 1-1-1.5"
        />
    </svg>
);
export const DiamondOptionSvg = ({ size = 28 }: { size?: number }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 256 256"
    >
        <path
            fill="#FFF"
            d="M240 128a15.85 15.85 0 0 1-4.67 11.28l-96.05 96.06a16 16 0 0 1-22.56 0l-96-96.06a16 16 0 0 1 0-22.56l96.05-96.06a16 16 0 0 1 22.56 0l96.05 96.06A15.85 15.85 0 0 1 240 128"
        />
    </svg>
);
